<template>
  <div class="error-msg" @click="goHome">
    <h1>Sorry bro. She ain't here.</h1>
    <p>
      <router-link :to="{ path: '/' }">{{ msg }}</router-link>
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      msg: "Move along, there's nothing to see here."
    };
  },
  methods: {
    goHome() {
      this.$router.push({ path: "/" });
    }
  }
};
</script>

<style lang="scss" scoped>
.error-msg {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  h1 {
    font-size: 3.5rem;
    letter-spacing: -1px;
    margin-bottom: 1rem;
  }
  p {
    margin: 0;
  }
  a {
    color: rgb(177, 177, 177);
    font-size: 1.9rem;
    font-weight: 300;
    text-decoration: none;
  }
}
</style>
